var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLineSpinner = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none",
  viewBox: "0 0 66 66",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-brand-primary, currentColor)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M12.494 12.494a29 29 0 1 1 25.043 49.149"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLineSpinner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/line-spinner.d8de4ab75861b8f26f59cb0ea9cb817e.svg";